import { toJpeg } from "html-to-image";
import { useEffect, useState } from "react";
import useAxiosPrivate from "../../api/useAxiosPrivate";
import { notify } from "../toast";
import { useParams } from "react-router-dom";
import '../../styles/dashboard.css';
import imageCompression from "browser-image-compression";
import Modal from 'react-modal';

const AdminEmployeeCard = () => {

    const HIERARCHY = {
        village_cluster: "Village Cluster",
        mandal_officer: "Mandal Officer",
        district_officer: "District Officer",
        area_manager: "Area Manager"
    };

    const { id } = useParams();
    const axiosPrivate = useAxiosPrivate();

    const [name, setName] = useState('');
    const [employeeId, setEmployeeId] = useState('');
    const [mobile, setMobile] = useState('');
    const [address, setAddress] = useState('');
    const [photo, setPhoto] = useState('');
    const [hierarchy, setHierarchy] = useState('');
    const [validity, setValidity] = useState('');
    const [loading, setLoading] = useState(false);

    const [openPhotoUpload, setOpenPhotoUpload] = useState(false);

    const fetchEmployeeDetails = async () => {
        try {

            const response = await axiosPrivate.get(`/admin/getEmployeeCard/${id}`);

            const data = response?.data
            setName(data?.name);
            setEmployeeId(data?.employeeId);
            setMobile(data?.mobile);
            setAddress(data?.address);
            setHierarchy(data?.role);
            setPhoto(`data:image/jpeg;base64,${bufferToBase64(data?.photo?.data)}`);

            const d = new Date(data?.createdAt);
            d.setFullYear(d.getFullYear() + 1);
            setValidity(String(d.getDate()).padStart(2, '0') + '/' +
                String(d.getMonth() + 1).padStart(2, '0') + '/' +
                d.getFullYear())

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchEmployeeDetails();
        // eslint-disable-next-line
    }, []);

    const handlePhoto = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);

            const photo = document.getElementById("photo");
            const fd = new FormData();

            // @ts-ignore
            if (!photo?.files[0]) {
                notify('info', 'Please select image before uploading')
                return
            }

            // @ts-ignore
            const compressedImage = await compressImage(photo?.files[0])
            fd.append('photo', compressedImage);

            const response = await axiosPrivate.post(`/employee/uploadEmployeePhoto/${id}`, fd,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });

            const success = response?.data?.success;
            if (success) {
                notify('success', success);
                fetchEmployeeDetails();
            }

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        } finally {
            setLoading(false);
            setOpenPhotoUpload(false);
        }
    }

    const compressImage = async (file) => {
        const options = {
            maxSizeMB: 0.048,
            maxWidthOrHeight: 600,
            useWebWorker: true,
        };

        const compressedFile = await imageCompression(file, options);
        return compressedFile;
    };

    const download = async () => {
        const node = document.getElementById("employee-id-card");
        try {
            // const dataUrl = await toJpeg(cardRef.current, {
            const dataUrl = await toJpeg(node, {
                quality: 0.95,
                pixelRatio: 2,
                cacheBust: true,
            });
            const link = document.createElement("a");
            link.download = `${name}-id-card.jpg`;
            link.href = dataUrl;
            link.click();
        } catch (err) {
            console.log(err)
        }
    };

    const bufferToBase64 = (bufferArray) => {
        const chunkSize = 100000;
        let base64String = '';

        for (let i = 0; i < bufferArray.length; i += chunkSize) {
            const chunk = bufferArray.slice(i, i + chunkSize);
            base64String += String.fromCharCode.apply(null, chunk);
        }

        return btoa(base64String);
    }

    return (
        <>

            <div
                style={{
                    margin: 20,
                    transform: "scale(0.4)",
                    transformOrigin: "top left",
                    width: "653px",
                    height: "1030px",
                }}
            >
                <div
                    id="employee-id-card"
                    style={{
                        width: "653px",
                        height: "1030px",
                        backgroundImage: `url('/ID_cards/ayush_employee.jpg')`,
                        backgroundSize: "100% 100%",
                    }}
                >

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            paddingTop: 300,
                            marginLeft: 45,
                            marginRight: 45,
                            wordBreak: 'break-word'
                        }}>

                        {photo ?
                            <img
                                src={photo}
                                alt="profile"
                                style={{
                                    width: 260,
                                    height: 340,
                                    objectFit: "contain",
                                    border: '2px solid #727290',
                                }}
                            />
                            :
                            <div style={{
                                width: 260,
                                height: 340,
                                objectFit: "contain",
                                border: '2px solid #727290',
                            }}></div>
                        }

                        <div
                            style={{
                                color: '#2d308d',
                                fontWeight: 'bold',
                                fontSize: '2.2rem',
                            }}>
                            {name}
                        </div>

                        <div
                            style={{
                                color: '#373340',
                                fontWeight: '600',
                                fontSize: '1.6rem'
                            }}>
                            {HIERARCHY[hierarchy]}
                        </div>

                        <div
                            style={{
                                color: '#373340',
                                fontWeight: '600',
                                fontSize: '1.6rem'
                            }}>
                            ID No. : {employeeId}
                        </div>

                    </div>

                    <div
                        style={{
                            color: '#373340',
                            fontWeight: '600',
                            fontSize: '1.6rem',
                            marginTop: 25,
                            marginLeft: 45,
                            marginRight: 45,
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}>
                        <div>
                            <div>
                                {address}
                            </div>

                            <div>
                                Mobile : {mobile}
                            </div>

                            <span
                                style={{
                                    color: '#373340',
                                    fontSize: '1.3rem'
                                }}>Card validity : {validity}
                            </span>
                        </div>

                        <img
                            src='/ID_cards/ayushcare_qr.png'
                            alt="qr"
                            style={{
                                width: 150,
                                height: 150,
                                objectFit: "contain",
                                marginLeft: 20
                            }}
                        />
                    </div>

                </div>

                <div
                    style={{
                        textAlign: 'center',
                        margin: '2rem',
                        transform: 'scale(2)'
                    }}>
                    <button className="add-btn" onClick={() => download()}>download</button>&nbsp;
                    <button className="add-btn" onClick={() => setOpenPhotoUpload(true)}>Change photo</button>
                </div>

            </div >

            <Modal
                isOpen={openPhotoUpload}
                onRequestClose={() => setOpenPhotoUpload(false)}
                style={{
                    overlay: { backgroundColor: "rgba(0,0,0,0.4)" },
                }}
                className='formContainer'
            >
                <div className='formWrapper'>
                    <h2 className='formTitle'>Employee photo upload</h2>
                    <form onSubmit={handlePhoto}>

                        <div className="formGroup">
                            <input
                                className="formInput"
                                type="file"
                                id="photo"
                                name='photo'
                            />
                        </div>
                        <div className="formRow">
                            <button
                                className='close-btn'
                                style={{ width: '95%' }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setOpenPhotoUpload(false);
                                }}>
                                <span>Close</span>
                            </button>
                            <button className="submitButton"> {loading ? <span className='spinner' /> : 'Upload'}</button>
                        </div>
                    </form>
                </div>

            </Modal >

        </>
    );
}

export default AdminEmployeeCard
